import { useContext, useState, useEffect } from "react";
import { AppContext } from '../application/provider';
import NavigationLinks from '../components/Navigation/NavigationLinks';
import "./Home.css";
import { Button } from "reactstrap";
import LogoBlanco from "../img/logo_mec_2.webp"
import Zorro from "../img/zorro.webp"
import ZorroEchado from "../img/zorro_echado.webp"
import { LogOut } from 'lucide-react';
import { BellSolid, GridSolid, SettingsSolid, SentinelSolid, AgencySolid } from '../components/Icons/FlowbiteIcons';
import { useNavigate } from "react-router-dom";
import NotificacionesService from '../axios_services/notificaciones.service';

function Home({ onLogout }) {

    const [state] = useContext(AppContext);
    const [isLoggingOut, setIsLoggingOut] = useState(false);
    const [alertCount, setAlertCount] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        if (Number(state.user?.perfil_id) !== 8) return;

        const fetchConteo = () => {
            NotificacionesService.conteoNoLeidas()
                .then(data => setAlertCount(data.total || 0))
                .catch(() => {});
        };

        fetchConteo();
        const intervalo = setInterval(fetchConteo, 30000);

        const handler = (e) => setAlertCount(e.detail.count);
        window.addEventListener('mec-notif-update', handler);

        return () => {
            clearInterval(intervalo);
            window.removeEventListener('mec-notif-update', handler);
        };
    }, [state.user]);

    const handleLogoutClick = async () => {
        setIsLoggingOut(true);
        try {
            await onLogout();
        } catch (error) {
            console.error("Error al cerrar sesión:", error);
        } finally {
            setIsLoggingOut(false);
        }
    };


    return (
        <div className="home">
            <div className="div-1">
                <img src={LogoBlanco} alt="Logo_blanco" className="logo-image" />
                <h2>Bienvenido a la página de MEC</h2>
            </div>
            <div className="div-2">
                <img src={Zorro} alt="Imagen de un zorro" className="zorro-image" />
            </div>
            <div className="div-3">
                <h3>{state.user?.nombres}</h3>
                <div className="home-icon-buttons">
                    <button
                        onClick={() => navigate('/')}
                        className="home-icon-button active"
                        title="Menú Principal"
                    >
                        <GridSolid size={24} />
                    </button>
                    {/* <button
                        onClick={() => window.open("https://www.sentinelperu.com/cliente/sentinel.aspx", "_blank")}
                        className="home-icon-button"
                        title="Sentinel"
                    >
                        <SentinelSolid size={24} />
                    </button>
                    <button
                        onClick={() => window.open('/#/agencias', '_blank')}
                        className="home-icon-button"
                        title="Agencias"
                    >
                        <AgencySolid size={24} />
                    </button> */}
                    <button
                        onClick={() => navigate('/notificaciones')}
                        className="home-icon-button"
                        title="Notificaciones"
                        style={{ position: 'relative' }}
                    >
                        <BellSolid size={24} />
                        {alertCount > 0 && (
                            <span style={{ position: 'absolute', top: '-4px', right: '-4px', background: '#ef4444', color: 'white', borderRadius: '999px', fontSize: '9px', fontWeight: 700, width: '16px', height: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1 }}>
                                {alertCount > 9 ? '9+' : alertCount}
                            </span>
                        )}
                    </button>
                    <button
                        onClick={() => navigate('/perfil')}
                        className="home-icon-button"
                        title="Configuración"
                    >
                        <SettingsSolid size={24} />
                    </button>
                </div>
                <div className="navlinks">
                    <NavigationLinks
                        mode="home"
                        perfilId={state.user?.perfil_id}
                        linkClassName="home-button-link"
                        paginate={true}
                        itemsPerPage={7}
                    />
                </div>
                <div className="zorrito-mobile">
                    <img src={ZorroEchado} alt="Zorrito Echado" />
                </div>
                <div className="boton-salir-mobile">
                    <LogOut
                        size={32}
                        onClick={onLogout}
                        style={{ cursor: 'pointer' }}
                    />
                </div>
            </div>
            <div className="div-4">
                <Button onClick={handleLogoutClick} disabled={isLoggingOut}>
                    {isLoggingOut ? "Saliendo..." : "Salir"}
                </Button>
            </div>

        </div>

    );
}

export default Home;